(() => {
  const handleFromUrl = value => {
    try { return new URL(value, location.origin).pathname.match(/\/products\/([^/]+)/)?.[1] || ''; }
    catch (_) { return ''; }
  };
  function init() {
    document.querySelectorAll('[data-ic-category-related]').forEach(section => {
      if (section.dataset.distinctBound) return;
      section.dataset.distinctBound = 'true';
      const cards = [...section.querySelectorAll('[data-related-handle]')];
      const limit = Number(section.dataset.relatedLimit) || 6;
      let signature = '';
      function sync() {
        const recent = new Set();
        document.querySelectorAll('[data-recently-viewed-container] [data-recently-viewed-card]').forEach(card => {
          const handle = card.querySelector('[data-product-handle]')?.dataset.productHandle ||
            handleFromUrl(card.querySelector('a[href*="/products/"]')?.getAttribute('href'));
          if (handle) recent.add(handle);
        });
        const next = [...recent].sort().join('|');
        if (next === signature && section.dataset.relatedReady) return;
        signature = next;
        let visible = 0;
        const seen = new Set();
        cards.forEach(card => {
          const handle = card.dataset.relatedHandle;
          const show = !recent.has(handle) && !seen.has(handle) && visible < limit;
          if (card.hidden === show) card.hidden = !show;
          if (show) { seen.add(handle); visible++; }
        });
        section.hidden = visible === 0;
        section.dataset.relatedVisible = String(visible);
        section.dataset.relatedReady = 'true';
      }
      sync();
      let scheduled = false;
      const queue = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; sync(); });
      };
      document.querySelectorAll('[data-recently-viewed-container]').forEach(container => {
        new MutationObserver(queue).observe(container, { childList: true, subtree: true });
      });
      window.addEventListener('pageshow', queue);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();